import { IPublicClientApplication } from '@azure/msal-browser';
import { setAccessToken } from '../api/tokenStore';

/**
 * Refreshes the B2C token and stores it in tokenStore
 * @param msalInstance - The MSAL instance
 * @param scopes - Array of scopes to request (defaults to ["User.Read"])
 * @returns Promise<boolean> - Returns true if successful, false otherwise
 */
export async function refreshAndStoreToken(
  msalInstance: IPublicClientApplication,
  scopes: string[] = ['User.Read']
): Promise<boolean> {
  try {
    const account = msalInstance.getActiveAccount();
    if (!account) {
      console.warn('No active account found for token refresh');
      return false;
    }

    const response = await msalInstance.acquireTokenSilent({
      account,
      forceRefresh: true,
      scopes,
    });

    // Store the refreshed token
    if (response.idToken) {
      setAccessToken(response.idToken);
      console.log('Token refreshed and stored successfully');
      return true;
    } else {
      console.warn('Token refresh succeeded but no idToken received');
      return false;
    }
  } catch (error) {
    console.error('Failed to refresh token:', error);
    return false;
  }
}

/**
 * Refreshes token and redirects to login if refresh fails
 * @param msalInstance - The MSAL instance
 * @param scopes - Array of scopes to request (defaults to ["User.Read"])
 * @returns Promise<boolean> - Returns true if successful, redirects to login if fails
 */
export async function refreshTokenOrLogin(
  msalInstance: IPublicClientApplication,
  scopes: string[] = ['User.Read']
): Promise<boolean> {
  const success = await refreshAndStoreToken(msalInstance, scopes);

  if (!success) {
    console.log('Token refresh failed, redirecting to login');
    await msalInstance.loginRedirect({
      scopes,
    });
  }

  return success;
}
